<template>
    <div class="flex items-end max-w-5xl gap-x-[6%]">
        <a
            aria-label="Alsterhaus"
            class="w-[40%]"
            href="https://www.alsterhaus.de"
        >
            <layout-logo-alsterhaus />
        </a>

        <a
            aria-label="KaDeWe"
            class="w-[20%]"
            href="https://www.kadewe.de"
        >
            <layout-logo-kadewe />
        </a>

        <a
            aria-label="Oberpollinger"
            class="w-[40%]"
            href="https://www.oberpollinger.de"
        >
            <layout-logo-oberpollinger />
        </a>
    </div>
</template>
